import {
  authApi,
  mergeStoredUser,
  readStoredToken,
  SPADES_UPDATED_EVENT,
} from '../services/authApi';

export async function refreshSpadesBalance() {
  const token = readStoredToken();
  if (!token) {
    return null;
  }

  try {
    const data = await authApi.getPaymentBalance(undefined, token);
    const nextBalance = data?.spade_balance;

    if (typeof nextBalance !== 'number' || Number.isNaN(nextBalance)) {
      return null;
    }

    mergeStoredUser({ spadesBalance: nextBalance });

    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent(SPADES_UPDATED_EVENT, {
          detail: { spadeBalance: nextBalance },
        }),
      );
    }

    return nextBalance;
  } catch (error) {
    console.warn('Failed to refresh Spades balance:', error);
    return null;
  }
}
